import React from "react";
import styles from "./style.module.scss";
import logo from "../../../assets/images/mashie-shield-with-text-white.png";
import { Label } from "semantic-ui-react";
import { Link } from "react-router-dom";
import DeprecatedBanner from "./v2/utils/DeprecatedBanner";
import APIVersionDropdown from "./v2/utils/APIVersionDropdown";

const Endpoint = ({ type, location }) => {
    let colour = "green"; // for GET
    switch (type) {
        case "POST":
            colour = "blue";
            break;
        case "PUT":
            colour = "purple";
            break;
        case "PATCH":
            colour = "yellow";
            break;
        case "DELETE":
            colour = "red";
            break;
        default:
            colour = "green";
    }

    return (
        <h3>
            <Label size='large' color={colour}>
                {type}
            </Label>
            <span className={styles.endpoint}>{location}</span>
        </h3>
    );
};

export default function Index() {
    return (
        <div className='app events' style={{ paddingBottom: "100px" }}>
            <div className={styles.fullHeader} alt='event'>
                <img className={styles.entityLogo} src={logo} alt='logo' />
                <h1 className={styles.headerText}>
                    Tee Time Documentation (v1)
                </h1>
            </div>
            <div className='container'>
                <APIVersionDropdown version='v1' />
                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>About this API</h2>
                        <p>
                            This API allows you to see tee time bookings, see
                            tee time booking messages, create tee times, update
                            tee times and send tee time messages.
                        </p>
                    </div>
                </div>

                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>Endpoints</h2>

                        <Endpoint type='GET' location='/teetimes' />
                        <p>
                            This endpoint returns a paginated list of all
                            teetimes the passed member has made.
                        </p>
                        <h3>Query parameters</h3>
                        <p>
                            <Label>member</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>The id of the member.</span>
                        </p>
                        <p className='mt-1'>
                            <Label>page</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <span className='ml-3'>
                                Sets the page number for the list of results.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>limit</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <span className='ml-3'>
                                Sets the number of records to return per page.
                                Defaults to 25.
                            </span>
                        </p>
                        <h3>Response</h3>
                        <Label basic color='green'>
                            200
                        </Label>
                        <span className='ml-2'>OK</span>
                        <pre className={styles.code}>
                            {`{
    "data": [
        {
            "_id": "6849a556f5e4cd297de8c5c8",
            "status": "requested",
            "paymentStatus": "unpaid",
            "club": {
                "_id": "6628e7725b71a695e65f39c1",
                "name": "...",
                "images": [
                    "b292c429-6bdd-42f1-9c60-dbd7a0b70d8b.jpg"
                ],
                "address1": "Address Line 1",
                "address2": "Address Line 2",
                "town": "Townsville",
                "county": "Countyshire",
                "postcode": "MM999MM",
                "country": "United Kingdom of Great Britain and Northern Ireland (the)"
            },
            "course": {
                "_id": "67337ac2441078167e728c29",
                "name": "..."
            },
            "date": "2025-05-01T11:00:00.000Z",
            "time": "10:00 - 11:00"
        },
        {
            "_id": "6849a83541d32d117c389739",
            "status": "booked",
            "paymentStatus": "pay club on arriva",
            "club": {
                "_id": "6628e7725b71a695e65f39c1",
                "name": "...",
                "images": [
                    "b292c429-6bdd-42f1-9c60-dbd7a0b70d8b.jpg"
                ],
                "address1": "Address Line 1",
                "address2": "Address Line 2",
                "town": "Townsville",
                "county": "Countyshire",
                "postcode": "MM999MM",
                "country": "United Kingdom of Great Britain and Northern Ireland (the)"
            },
            "course": {
                "_id": "6628e7955b71a695e65f3a56",
                "name": "..."
            },
            "date": "2025-05-01T12:00:00.000Z",
            "time": "07:35"
        }
        ...
    ],
    "total": 10
}`}
                        </pre>
                        <h3>Additional information</h3>
                        <p>
                            <Label>status</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <ul className='ml-3'>
                                <li>
                                    <strong>requested</strong> - default state
                                    when first made.
                                </li>
                                <li>
                                    <strong>awaiting confirmation</strong> -
                                    Awaiting the customer to confirm the date
                                    and time given to them by MASHIE.
                                </li>
                                <li>
                                    <strong>confirmed</strong> - The customer
                                    has confirmed the time that MASHIE has given
                                    them
                                </li>
                                <li>
                                    <strong>booked</strong> - MASHIE has made
                                    the booking at the club.
                                </li>
                                <li>
                                    <strong>cancellation requested</strong> -
                                    The member needs to cancel the booking.
                                    Please note, if this is done after the
                                    status was 'booked', the member may not
                                    receive a refund for their green fees. They
                                    will not receive a refund for their booking
                                    fees in any circumstances.
                                </li>
                                <li>
                                    <strong>cancelled</strong> - MASHIE has
                                    confirmed the cancellation of the booking.
                                </li>
                            </ul>
                        </p>
                        <p className='mt-1'>
                            <Label>paymentStatus</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <ul className='ml-3'>
                                <li>
                                    <strong>unpaid</strong> - default state when
                                    first made.
                                </li>
                                <li>
                                    <strong>pay mashie now</strong> - Awaiting
                                    the customer to pay mashie using the link
                                    provided (not in this endpoint)
                                </li>
                                <li>
                                    <strong>pay club now</strong> - Awaiting the
                                    customer to pay the club using the link
                                    provided (not in this endpoint) or via the
                                    details provided in a message (usually phone
                                    & reference)
                                </li>
                                <li>
                                    <strong>pay club on arrival</strong> - The
                                    customer needs to pay the club on arrival
                                    before they play.
                                </li>
                                <li>
                                    <strong>paid</strong> - MASHIE has
                                    confirmation that the payment for this
                                    booking has been recieved.
                                </li>
                                <li>
                                    <strong>no payment required</strong> - The
                                    player is not required to pay for this
                                    booking. Very rare and usually due to a
                                    customer services intervention.
                                </li>
                                <li>
                                    <strong>refunded</strong> - Any monies
                                    recieved for the green fees have been
                                    refunded to the customer. Booking fees are
                                    not refundable.
                                </li>
                            </ul>
                        </p>
                        <p className='mt-1'>
                            <Label>club.images</Label>
                            <Label basic className='ml-1'>
                                Array
                            </Label>
                            <span className='ml-3'>
                                Can be accessed at the following URL:
                                BASE_IMAGE_URL/content/clubs/images/:image
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>date</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                The date the booking has been requested on. The
                                date may change if the team are unable to make a
                                booking on the originally requested date. The
                                time portion of this date must be ignored as it
                                is defaulted to midday for timezone
                                compatability.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>time</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                This can either be the time block the customer
                                has requested (11:00 - 12:00) or the specific
                                tee off time (07:35) given by the club when the
                                booking has been made.
                            </span>
                        </p>
                        <div className={styles.spacer}></div>

                        <Endpoint type='GET' location='/teetimes/:id' />
                        <p>
                            This endpoint returns specific details about a
                            single tee time booking.
                        </p>
                        <h3>Path parameters</h3>
                        <p>
                            <Label>id</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The id of the tee time booking.
                            </span>
                        </p>
                        <h3>Query parameters</h3>
                        <p>
                            <Label>member</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>The id of the member.</span>
                        </p>
                        <h3>Response</h3>
                        <Label basic color='green'>
                            200
                        </Label>
                        <span className='ml-2'>OK</span>
                        <pre className={styles.code}>
                            {`{
    "data": {
        "_id": "6849a83541d32d117c389739",
        "status": "cancelled",
        "paymentStatus": "refunded",
        "additionalRequests": [],
        "players": 2,
        "paymentLink": "...",
        "club": {
            "_id": "6628e7725b71a695e65f39c1",
            "name": "...",
            "images": [
                "b292c429-6bdd-42f1-9c60-dbd7a0b70d8b.jpg"
            ],
            "address1": "Address Line 1",
            "address2": "Address Line 2",
            "town": "Townsville",
            "county": "Countyshire",
            "postcode": "MM999MM",
            "country": "United Kingdom of Great Britain and Northern Ireland (the)"
        },
        "course": {
            "_id": "6628e7955b71a695e65f3a56",
            "name": "course1club1"
        },
        "date": "2025-05-01T12:00:00.000Z",
        "time": "07:35",
        "price": 150,
        "bookingFee": 5.5
    }
}`}
                        </pre>
                        <h3>Additional information</h3>
                        <p>
                            <Label>status</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <ul className='ml-3'>
                                <li>
                                    <strong>requested</strong> - default state
                                    when first made.
                                </li>
                                <li>
                                    <strong>awaiting confirmation</strong> -
                                    Awaiting the customer to confirm the date
                                    and time given to them by MASHIE.
                                </li>
                                <li>
                                    <strong>confirmed</strong> - The customer
                                    has confirmed the time that MASHIE has given
                                    them
                                </li>
                                <li>
                                    <strong>booked</strong> - MASHIE has made
                                    the booking at the club.
                                </li>
                                <li>
                                    <strong>cancellation requested</strong> -
                                    The member needs to cancel the booking.
                                    Please note, if this is done after the
                                    status was 'booked', the member may not
                                    receive a refund for their green fees. They
                                    will not receive a refund for their booking
                                    fees in any circumstances.
                                </li>
                                <li>
                                    <strong>cancelled</strong> - MASHIE has
                                    confirmed the cancellation of the booking.
                                </li>
                            </ul>
                        </p>
                        <p className='mt-1'>
                            <Label>paymentStatus</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <ul className='ml-3'>
                                <li>
                                    <strong>unpaid</strong> - default state when
                                    first made.
                                </li>
                                <li>
                                    <strong>pay mashie now</strong> - Awaiting
                                    the customer to pay mashie using the link
                                    provided (not in this endpoint)
                                </li>
                                <li>
                                    <strong>pay club now</strong> - Awaiting the
                                    customer to pay the club using the link
                                    provided (not in this endpoint) or via the
                                    details provided in a message (usually phone
                                    & reference)
                                </li>
                                <li>
                                    <strong>pay club on arrival</strong> - The
                                    customer needs to pay the club on arrival
                                    before they play.
                                </li>
                                <li>
                                    <strong>paid</strong> - MASHIE has
                                    confirmation that the payment for this
                                    booking has been recieved.
                                </li>
                                <li>
                                    <strong>no payment required</strong> - The
                                    player is not required to pay for this
                                    booking. Very rare and usually due to a
                                    customer services intervention.
                                </li>
                                <li>
                                    <strong>refunded</strong> - Any monies
                                    recieved for the green fees have been
                                    refunded to the customer. Booking fees are
                                    not refundable.
                                </li>
                            </ul>
                        </p>
                        <p className='mt-1'>
                            <Label>club.images</Label>
                            <Label basic className='ml-1'>
                                Array
                            </Label>
                            <span className='ml-3'>
                                Can be accessed at the following URL:
                                BASE_IMAGE_URL/content/clubs/images/:image
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>date</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                The date the booking has been requested on. The
                                date may change if the team are unable to make a
                                booking on the originally requested date. The
                                time portion of this date must be ignored as it
                                is defaulted to midday for timezone
                                compatability.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>time</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                This can either be the time block the customer
                                has requested (11:00 - 12:00) or the specific
                                tee off time (07:35) given by the club when the
                                booking has been made.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>additionalRequests</Label>
                            <Label basic className='ml-1'>
                                Array
                            </Label>
                            <span className='ml-3'>
                                This is a list of the things a member can
                                request be available and orgainsed for them for
                                thier booking. Options can be: Buggies,
                                Trollies, Hotel, Spa, Lunch, & Dinner.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>paymentLink</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                This is the link the member will need to follow
                                to make payment for their booking to either
                                MASHIE or the club.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>price</Label>
                            <Label basic className='ml-1'>
                                Number
                            </Label>
                            <span className='ml-3'>
                                The total green fees for this booking due to
                                MASHIE or the club
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>bookingFee</Label>
                            <Label basic className='ml-1'>
                                Number
                            </Label>
                            <span className='ml-3'>
                                The total booking fee due for this booking to
                                MASHIE
                            </span>
                        </p>
                        <div className={styles.spacer}></div>

                        <Endpoint
                            type='GET'
                            location='/teetimes/:id/messages'
                        />
                        <p>
                            This endpoint returns all messages sent and received
                            regarding a specific tee time booking.
                        </p>
                        <h3>Path parameters</h3>
                        <p>
                            <Label>id</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The id of the tee time booking.
                            </span>
                        </p>
                        <h3>Query parameters</h3>
                        <p>
                            <Label>member</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>The id of the member.</span>
                        </p>
                        <h3>Response</h3>
                        <Label basic color='green'>
                            200
                        </Label>
                        <span className='ml-2'>OK</span>
                        <pre className={styles.code}>
                            {`{
    "data": [
        {
            "_id": "6849a87741d32d117c389a0b",
            "createdAt": "2025-06-11T16:01:59.379Z",
            "createdBy": {
                "_id": "6628d4e003a5903b70fc5821",
                "name": "Mashie System"
            },
            "note": "The status of your Tee time request for ... on ... has been updated to '...'",
        },
        ...
    ]
}`}
                        </pre>
                        <h3>Additional information</h3>
                        <p>
                            <Label>createdBy</Label>
                            <Label basic className='ml-1'>
                                Object
                            </Label>
                            <span className='ml-3'>
                                If the _id does not match that of the user, you
                                can consider it having come from MASHIE directly
                                as the _id could be one of many mashie staff, or
                                the mashie system user.
                            </span>
                        </p>
                        <div className={styles.spacer}></div>

                        <Endpoint type='POST' location='/teetimes' />
                        <p>
                            This endpoint creates a new tee time booking with
                            the information passed.
                        </p>
                        <h3>Request body</h3>
                        <p>
                            <Label>course</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The id of the course to be booked. Please note,
                                this is not the club.
                            </span>
                        </p>
                        <p className='mt-2'>
                            <Label>day</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The date of the month this booking is for.
                                (1-31)
                            </span>
                        </p>
                        <p className='mt-2'>
                            <Label>month</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The month of the year this booking is for.
                                (1-12)
                            </span>
                        </p>
                        <p className='mt-2'>
                            <Label>year</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The year this booking is for. (2025)
                            </span>
                        </p>
                        <p className='mt-2'>
                            <Label>timeslot</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The time slot the customer would ideally like to
                                start their round between. (10:00 - 11:00)
                            </span>
                        </p>
                        <p className='mt-2'>
                            <Label>players</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The number of players the booking is for. (1-8).
                                Ideally keep this to a maximum of 4.
                            </span>
                        </p>
                        <p className='mt-2'>
                            <Label>additionalRequests</Label>
                            <Label basic className='ml-1'>
                                Array
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                An array of the following possible options that
                                the customer would like to have included with
                                their booking. Note these may incur an
                                additional charge. Options can be: Buggies,
                                Trollies, Hotel, Spa, Lunch, & Dinner. Can be
                                empty.
                            </span>
                        </p>
                        <p className='mt-2'>
                            <Label>notes</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                Any notes the customer would like to include
                                about the booking. Can be a blank string, but
                                preferably "No notes given.".
                            </span>
                        </p>
                        <h3>Response</h3>
                        <Label basic color='green'>
                            201
                        </Label>
                        <span className='ml-2'>Created</span>
                        <pre className={styles.code}>
                            {`{
    "data": {
        "_id": "6849a83541d32d117c389739",
        "status": "cancelled",
        "paymentStatus": "refunded",
        "additionalRequests": [],
        "players": 2,
        "paymentLink": "...",
        "club": {
            "_id": "6628e7725b71a695e65f39c1",
            "name": "...",
            "images": [
                "b292c429-6bdd-42f1-9c60-dbd7a0b70d8b.jpg"
            ],
            "address1": "Address Line 1",
            "address2": "Address Line 2",
            "town": "Townsville",
            "county": "Countyshire",
            "postcode": "MM999MM",
            "country": "United Kingdom of Great Britain and Northern Ireland (the)"
        },
        "course": {
            "_id": "6628e7955b71a695e65f3a56",
            "name": "course1club1"
        },
        "date": "2025-05-01T12:00:00.000Z",
        "time": "07:35",
        "price": 150,
        "bookingFee": 5.5
    }
}`}
                        </pre>
                        <h3>Additional information</h3>
                        <p>
                            <Label>status</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <ul className='ml-3'>
                                <li>
                                    <strong>requested</strong> - default state
                                    when first made.
                                </li>
                                <li>
                                    <strong>awaiting confirmation</strong> -
                                    Awaiting the customer to confirm the date
                                    and time given to them by MASHIE.
                                </li>
                                <li>
                                    <strong>confirmed</strong> - The customer
                                    has confirmed the time that MASHIE has given
                                    them
                                </li>
                                <li>
                                    <strong>booked</strong> - MASHIE has made
                                    the booking at the club.
                                </li>
                                <li>
                                    <strong>cancellation requested</strong> -
                                    The member needs to cancel the booking.
                                    Please note, if this is done after the
                                    status was 'booked', the member may not
                                    receive a refund for their green fees. They
                                    will not receive a refund for their booking
                                    fees in any circumstances.
                                </li>
                                <li>
                                    <strong>cancelled</strong> - MASHIE has
                                    confirmed the cancellation of the booking.
                                </li>
                            </ul>
                        </p>
                        <p className='mt-1'>
                            <Label>paymentStatus</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <ul className='ml-3'>
                                <li>
                                    <strong>unpaid</strong> - default state when
                                    first made.
                                </li>
                                <li>
                                    <strong>pay mashie now</strong> - Awaiting
                                    the customer to pay mashie using the link
                                    provided (not in this endpoint)
                                </li>
                                <li>
                                    <strong>pay club now</strong> - Awaiting the
                                    customer to pay the club using the link
                                    provided (not in this endpoint) or via the
                                    details provided in a message (usually phone
                                    & reference)
                                </li>
                                <li>
                                    <strong>pay club on arrival</strong> - The
                                    customer needs to pay the club on arrival
                                    before they play.
                                </li>
                                <li>
                                    <strong>paid</strong> - MASHIE has
                                    confirmation that the payment for this
                                    booking has been recieved.
                                </li>
                                <li>
                                    <strong>no payment required</strong> - The
                                    player is not required to pay for this
                                    booking. Very rare and usually due to a
                                    customer services intervention.
                                </li>
                                <li>
                                    <strong>refunded</strong> - Any monies
                                    recieved for the green fees have been
                                    refunded to the customer. Booking fees are
                                    not refundable.
                                </li>
                            </ul>
                        </p>
                        <p className='mt-1'>
                            <Label>club.images</Label>
                            <Label basic className='ml-1'>
                                Array
                            </Label>
                            <span className='ml-3'>
                                Can be accessed at the following URL:
                                BASE_IMAGE_URL/content/clubs/images/:image
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>date</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                The date the booking has been requested on. The
                                date may change if the team are unable to make a
                                booking on the originally requested date. The
                                time portion of this date must be ignored as it
                                is defaulted to midday for timezone
                                compatability.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>time</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                This can either be the time block the customer
                                has requested (11:00 - 12:00) or the specific
                                tee off time (07:35) given by the club when the
                                booking has been made.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>additionalRequests</Label>
                            <Label basic className='ml-1'>
                                Array
                            </Label>
                            <span className='ml-3'>
                                This is a list of the things a member can
                                request be available and orgainsed for them for
                                thier booking. Options can be: Buggies,
                                Trollies, Hotel, Spa, Lunch, & Dinner.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>paymentLink</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                This is the link the member will need to follow
                                to make payment for their booking to either
                                MASHIE or the club.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>price</Label>
                            <Label basic className='ml-1'>
                                Number
                            </Label>
                            <span className='ml-3'>
                                The total green fees for this booking due to
                                MASHIE or the club
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>bookingFee</Label>
                            <Label basic className='ml-1'>
                                Number
                            </Label>
                            <span className='ml-3'>
                                The total booking fee due for this booking to
                                MASHIE
                            </span>
                        </p>
                        <div className={styles.spacer}></div>

                        <Endpoint type='PUT' location='/teetimes' />
                        <p>
                            This endpoint updates a tee time with the
                            information passed.
                        </p>
                        <h3>Path parameters</h3>
                        <p>
                            <Label>id</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The id of the tee time booking.
                            </span>
                        </p>
                        <h3>Query parameters</h3>
                        <p>
                            <Label>member</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>The id of the member.</span>
                        </p>
                        <h3>Request body</h3>
                        <p>
                            <Label>status</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                This is used to update the booking status with
                                the wishes of the customer. The status changes
                                can be "confirmed", or "cancellation requested".
                                "Confirmed" being that the customer is happy
                                with the date and time propsed by the concierge
                                team (note the user should not be able to
                                confirm the booking until the booking has moved
                                to the "awaiting confirmation" status).
                                "cancellation requested" being when the customer
                                would like to cancel the booking (note this
                                should only be shown to the user is the bookings
                                status is not "cancelled", "cancellation
                                requested", or "completed").
                            </span>
                        </p>
                        <h3>Response</h3>
                        <Label basic color='green'>
                            200
                        </Label>
                        <span className='ml-2'>Updated</span>
                        <pre className={styles.code}>
                            {`{
    "data": {
        "_id": "6849a83541d32d117c389739",
        "status": "cancelled",
        "paymentStatus": "refunded",
        "additionalRequests": [],
        "players": 2,
        "paymentLink": "...",
        "club": {
            "_id": "6628e7725b71a695e65f39c1",
            "name": "...",
            "images": [
                "b292c429-6bdd-42f1-9c60-dbd7a0b70d8b.jpg"
            ],
            "address1": "Address Line 1",
            "address2": "Address Line 2",
            "town": "Townsville",
            "county": "Countyshire",
            "postcode": "MM999MM",
            "country": "United Kingdom of Great Britain and Northern Ireland (the)"
        },
        "course": {
            "_id": "6628e7955b71a695e65f3a56",
            "name": "course1club1"
        },
        "date": "2025-05-01T12:00:00.000Z",
        "time": "07:35",
        "price": 150,
        "bookingFee": 5.5
    }
}`}
                        </pre>
                        <h3>Additional information</h3>
                        <p>
                            <Label>status</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <ul className='ml-3'>
                                <li>
                                    <strong>requested</strong> - default state
                                    when first made.
                                </li>
                                <li>
                                    <strong>awaiting confirmation</strong> -
                                    Awaiting the customer to confirm the date
                                    and time given to them by MASHIE.
                                </li>
                                <li>
                                    <strong>confirmed</strong> - The customer
                                    has confirmed the time that MASHIE has given
                                    them
                                </li>
                                <li>
                                    <strong>booked</strong> - MASHIE has made
                                    the booking at the club.
                                </li>
                                <li>
                                    <strong>cancellation requested</strong> -
                                    The member needs to cancel the booking.
                                    Please note, if this is done after the
                                    status was 'booked', the member may not
                                    receive a refund for their green fees. They
                                    will not receive a refund for their booking
                                    fees in any circumstances.
                                </li>
                                <li>
                                    <strong>cancelled</strong> - MASHIE has
                                    confirmed the cancellation of the booking.
                                </li>
                            </ul>
                        </p>
                        <p className='mt-1'>
                            <Label>paymentStatus</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <ul className='ml-3'>
                                <li>
                                    <strong>unpaid</strong> - default state when
                                    first made.
                                </li>
                                <li>
                                    <strong>pay mashie now</strong> - Awaiting
                                    the customer to pay mashie using the link
                                    provided (not in this endpoint)
                                </li>
                                <li>
                                    <strong>pay club now</strong> - Awaiting the
                                    customer to pay the club using the link
                                    provided (not in this endpoint) or via the
                                    details provided in a message (usually phone
                                    & reference)
                                </li>
                                <li>
                                    <strong>pay club on arrival</strong> - The
                                    customer needs to pay the club on arrival
                                    before they play.
                                </li>
                                <li>
                                    <strong>paid</strong> - MASHIE has
                                    confirmation that the payment for this
                                    booking has been recieved.
                                </li>
                                <li>
                                    <strong>no payment required</strong> - The
                                    player is not required to pay for this
                                    booking. Very rare and usually due to a
                                    customer services intervention.
                                </li>
                                <li>
                                    <strong>refunded</strong> - Any monies
                                    recieved for the green fees have been
                                    refunded to the customer. Booking fees are
                                    not refundable.
                                </li>
                            </ul>
                        </p>
                        <p className='mt-1'>
                            <Label>club.images</Label>
                            <Label basic className='ml-1'>
                                Array
                            </Label>
                            <span className='ml-3'>
                                Can be accessed at the following URL:
                                BASE_IMAGE_URL/content/clubs/images/:image
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>date</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                The date the booking has been requested on. The
                                date may change if the team are unable to make a
                                booking on the originally requested date. The
                                time portion of this date must be ignored as it
                                is defaulted to midday for timezone
                                compatability.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>time</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                This can either be the time block the customer
                                has requested (11:00 - 12:00) or the specific
                                tee off time (07:35) given by the club when the
                                booking has been made.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>additionalRequests</Label>
                            <Label basic className='ml-1'>
                                Array
                            </Label>
                            <span className='ml-3'>
                                This is a list of the things a member can
                                request be available and orgainsed for them for
                                thier booking. Options can be: Buggies,
                                Trollies, Hotel, Spa, Lunch, & Dinner.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>paymentLink</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <span className='ml-3'>
                                This is the link the member will need to follow
                                to make payment for their booking to either
                                MASHIE or the club.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>price</Label>
                            <Label basic className='ml-1'>
                                Number
                            </Label>
                            <span className='ml-3'>
                                The total green fees for this booking due to
                                MASHIE or the club
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>bookingFee</Label>
                            <Label basic className='ml-1'>
                                Number
                            </Label>
                            <span className='ml-3'>
                                The total booking fee due for this booking to
                                MASHIE
                            </span>
                        </p>
                        <div className={styles.spacer}></div>

                        <Endpoint
                            type='POST'
                            location='/teetimes/:id/messages'
                        />
                        <p>
                            This endpoint allows the user to send a message
                            about their tee time booking to the MASHIE team.
                        </p>
                        <h3>Path parameters</h3>
                        <p>
                            <Label>id</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The id of the tee time booking.
                            </span>
                        </p>
                        <h3>Query parameters</h3>
                        <p>
                            <Label>member</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>The id of the member.</span>
                        </p>
                        <h3>Request body</h3>
                        <p>
                            <Label>note</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The note the user would like to send. Whilst
                                there is no practical length limit, we reccomend
                                limiting to 1000 or so chars to keep things
                                succint for the team. There are no characterset
                                restrictions either. Emoji's shoud work.
                            </span>
                        </p>
                        <h3>Response</h3>
                        <Label basic color='green'>
                            200
                        </Label>
                        <span className='ml-2'>Created</span>
                        <pre className={styles.code}>
                            {`{
    "data": {
        "createdBy": {
            "_id": "682354450b177892b5b49207",
            "name": "test test"
        },
        "note": "testomg",
        "createdAt": "2025-06-11T21:23:52.624Z"
    }
}`}
                        </pre>
                        <div className={styles.spacer}></div>
                    </div>
                </div>
            </div>
            <DeprecatedBanner version='v1' />
        </div>
    );
}
